import React, { createContext, useState, useEffect, useContext } from 'react';

// Create a context for the Transaction ID
export const PersistedTransactionIdContext = createContext();

// Provider component to manage the transaction ID
export const PersistedTransactionIdProvider = ({ children }) => {
  const [transactionId, setTransactionId] = useState('');

  useEffect(() => {
    // Check if a transaction ID is already in sessionStorage
    let existingId = sessionStorage.getItem('transactionID');

    // If not, generate a new one and store it
    if (!existingId) {
      // existingId = window.crypto.randomUUID();  // Generate a new UUID
      existingId = `${new Date().toISOString().replace(/[-:.T]/g, '')}${
        Math.floor(Math.random() * 900) + 100
      }`;
      sessionStorage.setItem('transactionID', existingId);
    }

    setTransactionId(existingId); // Set the transaction ID to state
  }, []);

  return (
    <PersistedTransactionIdContext.Provider value={transactionId}>
      {children}
    </PersistedTransactionIdContext.Provider>
  );
};

export const usePersistedTransactionId = () => {
  return useContext(PersistedTransactionIdContext);
};
